import { Preferences } from '@capacitor/preferences';
import { isNativePlatform } from './native';

const TOKEN_KEY = 'auth_session_token';

/**
 * In-memory copy of the session token. Kept in sync with native storage so
 * request interceptors can read it synchronously. Stays null on web, where
 * authentication relies on cookies and this whole module is a no-op.
 */
let cachedToken: string | null = null;

/**
 * Loads the persisted session token into memory. Must be awaited before the
 * first render so the initial session request carries the bearer header.
 */
export async function hydrateAuthToken(): Promise<void> {
  if (!isNativePlatform()) return;
  const { value } = await Preferences.get({ key: TOKEN_KEY });
  cachedToken = value;
}

/** Returns the cached session token, or null when none is stored. */
export function getAuthToken(): string | null {
  return cachedToken;
}

/** Caches the session token and persists it to native storage. */
export async function setAuthToken(token: string): Promise<void> {
  if (!isNativePlatform()) return;
  cachedToken = token;
  await Preferences.set({ key: TOKEN_KEY, value: token });
}

/** Clears the cached session token and removes it from native storage. */
export async function clearAuthToken(): Promise<void> {
  if (!isNativePlatform()) return;
  cachedToken = null;
  await Preferences.remove({ key: TOKEN_KEY });
}
